export function isKeyEnter(ev) {
  return ev.key === 'Enter';
}
